module.exports = __webpack_public_path__ + "static/Amazon Webstore-dfd588b6f73b91fcdac1f91db66aea20.svg";